import React, { forwardRef } from 'react'

import { IconProps } from './types'

const LongText = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2 4H14M2 8H14M2 12H11" stroke={stroke || 'currentColor'} />
    </svg>
  ),
)
LongText.displayName = 'LongText'

export default LongText
